<template>
  <button class="cus-btn" :style="{ backgroundColor: bgColor, color: textColor }" :class="classes" @click="$emit('click')">
    <slot></slot>
  </button>
</template>
<script>
export default {
    name: 'CusButton',
    props: {
        color:{
            type: String,
            default: 'blue'
        },
        type: {
            type: String,
            default: 'small' // 'small' or 'big'
        },
        txtColor: {
            type: String,
            default: 'black'
        }
    },
    computed:{
        bgColor() {
            return this.color === 'purple' ? '#D58FF8' :
                   this.color === 'blue' ? '#8FC4FA' :
                   this.color === 'pink' ? '#fe64a9' :
                   'transparent'; // default gray
        },
        classes(){
            return {
                'cus-btn-small': this.type === 'small',
                'cus-btn-big': this.type === 'big',
            };
        },
        textColor() {
            return this.txtColor === 'black' ? '#000000' :
                   this.txtColor === 'white' ? '#fff' :
                   '#333'; // default black
        }
    }
}
</script>

<style scoped>
    .cus-btn{
        outline: none;
        border: none;
        font-size: .24rem;
        cursor: pointer;
        font-weight: 550;
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: Adobe Heiti Std;
        letter-spacing: 1px;
    }
    .cus-btn-small{
        padding: 0 .2rem;
        font-size: .14rem;
        cursor: pointer;
        height: .36rem;
        border-radius: .18rem;
    }
    .cus-btn-big{
        padding: 0 .23rem;
        font-size: .16rem;
        cursor: pointer;
        height: .4rem;
        border-radius: .21rem;
    }
@media (max-width: 640px) {
  .cus-btn{
        letter-spacing: 1px;
    }
    .cus-btn-small{
        padding: 0 2rem;
        font-size: 1rem;
        height: 2.8rem;
        border-radius: 1.4rem;
    }
    .cus-btn-big{
        padding: 0 1.8rem;
        font-size: 1.2rem;
        height: 3rem;
        border-radius: 1.5rem;
    }
}

</style>